import {
  makeStyles,
  shorthands,
  Button,
  PopoverTrigger,
  PopoverSurface,
  Popover
} from "@fluentui/react-components";
import { MoreHorizontal20Regular } from "@fluentui/react-icons";
import { useNavigate } from "react-router-dom";
import { AppCard } from "./AppCard";

const useStyles = makeStyles({
  popover: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.padding("5px", "0px"),
  }
});

export type LicenseAssistantAppCardProps = {
  className?: string;
  img: string;
  onClick?: () => void,
}

export const LicenseAssistantAppCard = (props: LicenseAssistantAppCardProps) => {
  const navigate = useNavigate();
  const styles = useStyles();

  return (
    <AppCard className={props.className}
      title="License Assistant"
      description="Use our Assistant to manage your licenses and services"
      img = {props.img}
      onClick={props.onClick}
      action={
        <Popover positioning="below-end">
          <PopoverTrigger disableButtonEnhancement>
            <Button
              appearance="transparent"
              icon={<MoreHorizontal20Regular />}
              aria-label="More options"
              onClick={(event: React.MouseEvent) => {
                event.stopPropagation();
              }}
            />
          </PopoverTrigger>
          <PopoverSurface className={styles.popover}>
            <Button
              appearance="subtle"
              onClick={(event: React.MouseEvent) => {
                navigate("../history-feed");
                event.stopPropagation();
              }}
            >
              History Feed
            </Button>
            <Button
              appearance="subtle"
              onClick={(event: React.MouseEvent) => {
                navigate("../license-order");
                event.stopPropagation();
              }}
            >
              Create Request
            </Button>
          </PopoverSurface>
        </Popover>
      }
    />
);
};